import fetchLoginDetails from "../components/apis/loginAPI";

// Function to hash the password
const hashPassword = async (password) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(password);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');

    return hashHex;
};

// Function to generate JWT token
const generateToken = (username) => {
    const header = {
        alg: 'HS256',
        typ: 'JWT'
    };

    const payload = {
        username,
        exp: Math.floor(Date.now() / 1000) + (60 * 60), // 1 hour expiration
    };

    const base64Header = btoa(JSON.stringify(header));
    const base64Payload = btoa(JSON.stringify(payload));
    const signature = btoa(base64Header + '.' + base64Payload); // Simplified signature for demo

    return `${base64Header}.${base64Payload}.${signature}`;
};

// Function to verify credentials
export const verifyCredentials = async (username, password) => {
    const loginDetails = await fetchLoginDetails();
    if (!loginDetails) return false;
    if (username !== loginDetails.username) return false;
    
    const hashedPassword = await hashPassword(password);
    return hashedPassword === loginDetails.passwordHash;
};

// Function to handle login
export const handleLogin = async (username, password) => {
    const isValid = await verifyCredentials(username, password);

    if (isValid) {
        const token = generateToken(username);
        localStorage.setItem('adminToken', token);
        localStorage.setItem('adminUsername', username);
        return true;
    }
    
    return false;
};

// Function to check if user is authenticated
export const isAuthenticated = () => {
    const token = localStorage.getItem('adminToken');
    if (!token) return false;

    try {
        const [, payloadBase64] = token.split('.');
        const payload = JSON.parse(atob(payloadBase64));
        
        // Check if token is expired
        if (payload.exp < Math.floor(Date.now() / 1000)) {
            localStorage.removeItem('adminToken');
            localStorage.removeItem('adminUsername');
            return false;
        }
        
        return true;
    } catch {
        return false;
    }
};

// Function to handle logout
export const handleLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUsername');
};